import * as React from 'react';
import { TabSize, TabVariant } from './types';

/**
 * Context value interface for the Tabs component
 * @interface TabsContextValue
 * @property {TabVariant} variant - The variant of the tabs
 * @property {TabSize} size - The size of the tabs
 */
interface TabsContextValue {
  variant: TabVariant;
  size: TabSize;
}

/**
 * React context for sharing tabs configuration between parent and child components
 * @context TabsContext
 */
const TabsContext = React.createContext<TabsContextValue>({
  variant: TabVariant.Default,
  size: TabSize.Md,
});

export { TabsContext };
export type { TabsContextValue };
